import { getUrl, sessionExpired } from '../setEnvironment';

class TasksAPI {
  constructor() {
    this.URL = getUrl();
    this.getTasks = this.getTasks.bind(this);
    this.getLastTask = this.getLastTask.bind(this);
    this.newTask = this.newTask.bind(this);
    this.cancelTask = this.cancelTask.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.returnPod = this.returnPod.bind(this);
    this.resendAPI = this.resendAPI.bind(this);
    this.querytaskStatusStart = this.querytaskStatusStart.bind(this);
    this.pendingToReturn = this.pendingToReturn.bind(this);
    this.pauseQueueTasks = this.pauseQueueTasks.bind(this);
    this.resumeQueueTasks = this.resumeQueueTasks.bind(this);
    this.getCallbacksPending = this.getCallbacksPending.bind(this);
    this.sendCallbacksPending = this.sendCallbacksPending.bind(this);
    this.resyncSecurities = this.resyncSecurities.bind(this);
    this.getDashboardStats = this.getDashboardStats.bind(this);
    this.getTaskTrend = this.getTaskTrend.bind(this);
  }

  async resendAPI(token) {
    try {
      const response = await fetch(this.URL + '/task/dispatchTasks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });

      if (sessionExpired(response.status)) return;

      const json = await response;
      return json;
    } catch (error) {
      throw error;
    }
  }

  async querytaskStatusStart(token) {
    try {
      const response = await fetch(this.URL + '/task/querytaskStatusStart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;

      const json = await response;
      return json;
    } catch (error) {
      throw error;
    }
  }

  async pendingToReturn(sgtTaskId, taskCode, sgpWS, workstationPosition, rackCode, token) {
    let raw = JSON.stringify({ sgtTaskId, taskCode, sgpWS, workstationPosition, rackCode });
    try {
      const response = await fetch(this.URL + '/task/toPendingReturn', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;

      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async updateTask(taskCode, priority, workstationCandidates, estimatedDurationSeconds, rackCode, face, token) {
    console.log({ workstationCandidates });
    console.log({ token });
    let raw = JSON.stringify([
      {
        taskCode: taskCode,
        priority: priority,
        workstationCandidates: workstationCandidates,
        estimatedDurationSeconds: estimatedDurationSeconds,
        rackCode: rackCode,
        face: face,
      },
    ]);
    try {
      const response = await fetch(this.URL + '/task/updateTask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: rack/sgpWS ya no se envían — el backend los deriva de la propia tarea
  // (taskCode), que antes solo servían para validar/descartar lo que mandaba el cliente.
  async returnPod(taskCode, token, inbound) {
    let raw = JSON.stringify({
      taskCode: taskCode,
      inbound: inbound,
    });
    try {
      const response = await fetch(this.URL + '/processingtask/returnPod', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();

      if (!response.ok || response.status >= 400) {
        throw json;
      }

      return json;
    } catch (e) {
      throw e;
    }
  }

  async cancelTask(taskCode, response2, token) {
    let raw = JSON.stringify({
      taskCode: taskCode,
      forceCancel: '1',
      matterArea: response2,
    });
    try {
      const response = await fetch(this.URL + '/rcs/cancelTask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const resp = await response.json();
      return resp;
    } catch (e) {
      throw e;
    }
  }

  async newTask(sgtTaskid, priority, workstationCandidates, estimatedDurationSeconds, rackCode, face, token) {
    const taskCode = sgtTaskid.toString();
    console.log({ workstationCandidates });
    let raw = JSON.stringify([
      {
        taskCode: taskCode,
        priority: priority,
        workstationCandidates: workstationCandidates,
        estimatedDurationSeconds: estimatedDurationSeconds,
        rackCode: rackCode,
        face: face,
      },
    ]);
    try {
      const response = await fetch(this.URL + '/task/createTask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (response.status >= 200 && response.status < 300 && json.numberTasksRejected === 0) {
        return json;
      } else {
        throw json;
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  // P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad).
  async getTasks(token, size, page, status, rack, workstation, position, priorityMin, priorityMax) {
    let url = `${this.URL}/task/getAllTasks?size=${size}&page=${page}`;
    if (status !== undefined && status !== '') url += `&status=${encodeURIComponent(status)}`;
    if (rack) url += `&rack=${encodeURIComponent(rack)}`;
    if (workstation) url += `&workstation=${encodeURIComponent(workstation)}`;
    if (position) url += `&position=${encodeURIComponent(position)}`;
    if (priorityMin !== undefined && priorityMin !== '') url += `&priorityMin=${encodeURIComponent(priorityMin)}`;
    if (priorityMax !== undefined && priorityMax !== '') url += `&priorityMax=${encodeURIComponent(priorityMax)}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-139 (Fase 2): KPIs de la fila superior del Dashboard.
  async getDashboardStats(token) {
    try {
      const response = await fetch(this.URL + '/task/getDashboardStats', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-139 (Fase 2): gráfico de tendencia del Dashboard.
  async getTaskTrend(token) {
    try {
      const response = await fetch(this.URL + '/task/getTaskTrend', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async getLastTask(token) {
    try {
      const response = await fetch(this.URL + '/task/getLastTask', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async pauseQueueTasks(taskCode, token) {
    let raw;
    if (taskCode == null) {
      raw = JSON.stringify({});
    } else {
      raw = JSON.stringify({ tasks: [taskCode] });
    }
    try {
      const response = await fetch(this.URL + '/task/pauseQueueTasks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async resumeQueueTasks(taskCode, token) {
    let raw;
    if (taskCode == null) {
      raw = JSON.stringify({});
    } else {
      raw = JSON.stringify({ tasks: [taskCode] });
    }
    try {
      const response = await fetch(this.URL + '/task/resumeQueueTasks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: raw,
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async resyncSecurities(token) {
    try {
      const response = await fetch(this.URL + '/processingtask/resyncSecurities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (e) {
      throw e;
    }
  }

  async getCallbacksPending(username, token) {
    try {
      const response = await fetch(this.URL + '/processingtask/getCallbacksPending', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }
  async sendCallbacksPending(username, token) {
    try {
      const response = await fetch(this.URL + '/processingtask/queryCallbacks', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      const obj = {
        status: response.status,
        message: json.message,
      };
      return obj;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
}

let _tasksAPI = null;

const initTasksAPI = () => {
  if (!_tasksAPI) {
    _tasksAPI = new TasksAPI();
  }
  return _tasksAPI;
};

const getTasksAPI = () => {
  return initTasksAPI();
};

export { initTasksAPI, getTasksAPI };
